import { Wizard } from '@/components/layout/Wizard';
import { Background, Container } from '@/components/wm';
import { setStoreResource } from '@/utils/store';
import React from 'react';
import { Configuration } from '../Configuration';
import { SelectAssets } from './Content/SelectAssets';

export default function EditIntegration ({ integration }) {
    const assetsAttributes = integration.assets.map(asset => ({
        id: asset.id,
        name: asset.name,
        asset_reference: asset.asset_reference,
        local_reference: asset.local_reference ?? 0,
        create_work_orders: asset.create_work_orders ?? true,
        create_markers: asset.create_markers ?? true,
        _destroy: false // default to false for existing assets
    }));

    const initialData = {
        assetsAttributes: assetsAttributes || [],
        configurationId: integration.configuration_id || '',
        id: integration.id || '',
        indicatorId: integration.indicator_id || '',
        licenseId: integration.license_id || '',
        name: integration.name || '',
        partnerId: integration.partner_id || '',
        siteId: integration.site_id || ''
    };

    const steps = [
        { Component: SelectAssets, title: i18next.t('integrations.edit_integration'), description: i18next.t('integrations.nextbitt.select_assets_description') },
        { Component: Configuration, title: i18next.t('integrations.edit_integration'), description: i18next.t('integrations.nextbitt.configuration_description') }
    ];

    const handleSubmit = async data => {
        return await setStoreResource('integrations', data);
    };

    return (
        <Background>
            <Container>
                <Wizard
                    handleSubmit={handleSubmit}
                    initialData={initialData}
                    steps={steps}
                />
            </Container>
        </Background>
    );
}
